module.exports = __webpack_public_path__ + "static/care-package-list-19d2e65cb8797aaa2682c91c7212f5f0.pdf";